export class EndPointConstant {
    static Authenticate: any = {
        Controller: '/Authentication/',
        Authenticate: () => this.Authenticate.Controller + 'Authenticate',
    }

    static DesignationCourse: any = {
        Controller: '/DesignationCourse/',
        GetDesignationCoursesForLoggedInUser: () => this.DesignationCourse.Controller + 'GetDesignationCoursesForLoggedInUser'
    }

    static Course: any = {
        Controller: '/Course/',
        GetSingleCourseContentAndContentDetails: () => this.Course.Controller + 'GetSingleCourseContentAndContentDetails',
        GetCourseSidebarData: (courseId: any) => `${this.Course.Controller}sidebar-data/${courseId}`
    }

    // 
    static Instructor: any = {
        Controller: '/Instructor/',
        GetInstructor: (id: any) => `${this.Instructor.Controller}${id}`,
        GetInstructorWithSkills: (instructorId: any) => `${this.Instructor.Controller}with-skills/${instructorId}`,
    };

    // Designation EndPoint Constants

    static Designation : any = {
        Controller : '/Designation/',
        GetDesignations : () => this.Designation.Controller 
    };

    // Dashboard EndPoint Constants

    static AdminDashboard : any = {
        Controller : '/Dashboard/',
        //GetAllDashboardCounts: () => this.AdminDashboard.Controller + 'GetAllDashboardCounts',
        GetDesignationWiseCoursesAndEmployees : () => this.AdminDashboard.Controller + 'GetDesignationWiseCoursesAndEmployees',
        GetDesignationLevelStatus : () => this.AdminDashboard.Controller + 'GetDesignationLevelStatus',
        GetDesignationAndCoursesList : () => this.AdminDashboard.Controller + 'GetDesignationAndCoursesList',
        GetAllCoursesNamesList : () => this.AdminDashboard.Controller + 'GetAllCoursesNamesList',
        GetAllEmployeesNamesList : () => this.AdminDashboard.Controller + 'GetAllEmployeesNamesList',
        GetAllInstructorsNamesList : () => this.AdminDashboard.Controller + 'GetAllInstructorsNamesList',
        GetDivisions : () => this.AdminDashboard.Controller + 'GetDivisions',
        GetDistricts : () => this.AdminDashboard.Controller + 'GetDistricts',
        GetTehsils : () => this.AdminDashboard.Controller + 'GetTehsils',
        GetHealthFacilities : () => this.AdminDashboard.Controller + 'GetHealthFacilities',
        GetCourseCompletionStatus : () => this.AdminDashboard.Controller + 'GetCourseCompletionStatus',
        GetEmployeesList: () => this.AdminDashboard.Controller + 'GetEmployeesList',
        GetAllDesignationsCount: () => this.AdminDashboard.Controller + 'GetAllDesignationsCount',
        GetAllCoursesCount: () => this.AdminDashboard.Controller + 'GetAllCoursesCount',
        GetAllEmployeesCount: () => this.AdminDashboard.Controller + 'GetAllEmployeesCount',
        GetAllInstructorsCount : () => this.AdminDashboard.Controller + 'GetAllInstructorsCount',
        GetCoursesList : () => this.AdminDashboard.Controller + 'GetCoursesList',
        GetEmployeeDetail : () => this.AdminDashboard.Controller + 'GetEmployeeDetail',
        GetCourseDetail : () => this.AdminDashboard.Controller + 'GetCourseDetail',
        GetDesignationDetail : () => this.AdminDashboard.Controller + 'GetDesignationDetail',
        GetInstructorDetail : () => this.AdminDashboard.Controller + 'GetInstructorDetail',
        GetDashboardAllCounts :() => this.AdminDashboard.Controller + 'GetDashboardAllCounts',
        GetDesignationWiseCourseEnrollments :() => this.AdminDashboard.Controller + 'GetDesignationWiseCourseEnrollments',
        GetEmployeeStatusByDesignationAndCourseId: () => this.AdminDashboard.Controller + 'GetEmployeeStatus',
        GetDesignationWiseEmployeeStatusList: () => this.AdminDashboard.Controller + 'GetDesignationWiseEmployeeStatusList',
        GetEmployeeWiseEnrollments: () => this.AdminDashboard.Controller + 'GetEmployeeWiseEnrollments',
        GetEmployeeStatusByEmployeeId: () => this.AdminDashboard.Controller + 'GetEmployeeStatus',
        GetAllEmployeesDetailList: () => this.AdminDashboard.Controller + 'GetAllEmployeesDetailList',
        GetCourseEnrollments: () => this.AdminDashboard.Controller + 'GetCourseWiseEnrollments',
        GetEmployeeStatusByCourseId: () => this.AdminDashboard.Controller + 'GetCourseWiseEmployeeList',
        GetAllCourses : () => this.AdminDashboard.Controller + 'GetAllCourses',
        GetAllCourseModules : () => this.AdminDashboard.Controller + 'GetAllCourseModules',
        GetAllCourseSubModules : () => this.AdminDashboard.Controller + 'GetAllCourseSubModules',
        GetAssignedCoursesDetailsByEmployeeId : () => this.AdminDashboard.Controller + 'GetAssignedCoursesDetails',
        GetCompletedCoursesDetailsByEmployeeId : () => this.AdminDashboard.Controller + 'GetCompletedCoursesDetails',
        GetEnrolledCoursesDetailsByEmployeeId : () => this.AdminDashboard.Controller + 'GetEnrolledCoursesDetails',
        GetEmployeeWiseCourseDetailCompleteData : () => this.AdminDashboard.Controller + 'GetAllEmployeeWiseCourseDetailCompleteDataList',
        GetFilteredUsers : () => this.AdminDashboard.Controller + 'GetFilteredUsers',
        GetUserAndCoursesReport : () => this.AdminDashboard.Controller + 'GetUserAndCoursesReport'
    };
    
}